import { type TraceStyleSheet, TraceList, NumericDateRepresentation } from 'libchartium';
import { map } from '#lib/utils/generators.js';
import { v4 as uuid } from 'uuid';
import { type Unit } from '#lib/overview/utils/units.js';

export async function xyToTraceList({
  trace,
  id,
  label,
  unit,
  style,
}: {
  trace: { x: Date[]; y: number[] } | undefined;
  id: string;
  label: string;
  unit: Unit;
  style?: TraceStyleSheet;
}): Promise<TraceList> {
  if (!trace || trace.x.length === 0) return TraceList.empty();

  const { x, y } = trace;

  const data = new Float64Array(2 * x.length);
  for (let i = 0; i < x.length; i++) {
    data[2 * i] = +x[i];
    data[2 * i + 1] = y[i];
  }

  const tl = await TraceList.fromRowBuffer({
    data,
    ids: [id],
    xType: 'f64',
    yType: 'f64',
    labels: [[id, label]],
    style,
    xDataUnit: NumericDateRepresentation.EpochMilliseconds(),
    yDataUnit: unit,
  });

  return tl;
}

export function getChartiumTraces({
  data,
  unit,
  style,
}: {
  data: Map<string, { x: Date[]; y: number[]; id?: string }>;
  unit: Unit;
  style?: TraceStyleSheet;
}): Promise<TraceList> {
  return Promise.all(
    map(data.entries(), ([label, { x, y, id }]) =>
      xyToTraceList({
        trace: { x, y },
        id: id ?? uuid(),
        label,
        unit,
        style,
      }),
    ),
  ).then((ts) => TraceList.union(...ts));
}
